import { useRef, useCallback, useContext, useMemo, useState } from 'react'
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Box, Select } from "@chakra-ui/react"
import { Textarea, Image, Button, Input, Stack } from '@chakra-ui/react'
import { Card, CardBody } from '@chakra-ui/react'
import { AdsContext } from '../../store/ads'
import { UserContext } from '../../store/user'
import { useRouter } from 'next/router'
import axios from 'axios'

const VariationModal = ({ isOpen, onClose }) => {
	const { state: adsState, dispatch: adsDispatch, saveCampaign } = useContext(AdsContext)
	const { state: userState } = useContext(UserContext)
	const router = useRouter()
	const adTitleRef = useRef()
	const adDescriptionRef = useRef()
	const [platform, setPlatform] = useState()

	const onCreate = useCallback(async () => {
		const _variation = { title: adTitleRef.current.value, description: adDescriptionRef.current.value, image: '/uploaded/photo.jpeg', platform }
		let _campaign
		if (!adsState.campaign) {
			_campaign = { variations: [] }
		} else {
			_campaign = adsState.campaign
		}
		_campaign.variations.push(_variation)
		adsDispatch({ type: 'SET_CAMPAIGN', value: _campaign })

		if(userState.token) {
			if (_campaign.id) {
				saveCampaign(_campaign.id, _campaign.variations)
			} else {
				const { data } = await axios.post(`/api/campaigns/add`, { campaign: _campaign }, { headers: { 'Content-Type': 'application/json', authorization: userState.token } })
				const _campaigns = [{ id: data.campaignId }]
				adsDispatch({ type: 'SET_CAMPAIGNS', value: _campaigns })
				router.push(`/ads/${data.campaignId}`, null, { shallow: true })
			}
		}

	}, [adsState.campaign, platform, userState.token])

	const onUpdate = useCallback(() => {
		const _variations = adsState.campaign.variations.map((v, i) => {
			if (i === adsState.selectedVariation) {
				v = { ...v, title: adTitleRef.current.value, description: adDescriptionRef.current.value, platform }
			}
			return v
		})
		adsState.campaign.variations = _variations
		adsDispatch({ type: 'SET_CAMPAIGN', value: adsState.campaign })
		adsDispatch({ type: "SET_SELECTED_VARIATION", value: null });
		if(userState.token) {
			saveCampaign(adsState.campaign.id, _variations)
		}
	}, [adsState.campaign, adsState.selectedVariation, platform, userState.token])

	const variation = useMemo(() => {
		if (!adsState.campaign || adsState.selectedVariation === undefined) {
			return
		}
		return adsState.campaign.variations[adsState.selectedVariation]
	}, [adsState.campaign, adsState.selectedVariation])

	return (
		<Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={() => { adsDispatch({ type: "SET_SELECTED_VARIATION", value: null }); onClose() }}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>{variation ? "Edit variation" : "Create variation"}</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					<Card maxH={'500px'}>
						<CardBody>
							<Stack spacing='2'>
								<Input ref={adTitleRef} defaultValue={variation?.title} placeholder='Title' />
								<Select onChange={(e) => setPlatform(e.target.value)} placeholder='Select Platform' defaultValue={variation?.platform}>
									<option value='facebook'>Facebook</option>
									<option value='instagram'>Instagram</option>
									<option value='reddit'>Reddit</option>
									<option value='google'>Google</option>
									<option value='bing'>Bing</option>
									<option value='linkedin'>Linkedin</option>
									<option value='twitter'>Twitter</option>
									<option value='pinterest'>Pinterest</option>
									<option value='Other'>Other</option>
								</Select>
								<Textarea ref={adDescriptionRef} defaultValue={variation?.description} placeholder='Description' />
								<Image src={variation?.image ?? "/uploaded/photo.jpeg"} objectFit='cover' />
							</Stack>
						</CardBody>
					</Card>
				</ModalBody>
				<ModalFooter>
					<Button onClick={() => { variation ? onUpdate() : onCreate(); onClose() }} colorScheme='purple'>Done</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	)
}
export default VariationModal